import { render } from "./property-list-list.vue?vue&type=template&id=bc46af5a&scoped=true"
import script from "./property-list-list.vue?vue&type=script&lang=js"
export * from "./property-list-list.vue?vue&type=script&lang=js"

import "./property-list-list.vue?vue&type=style&index=0&id=bc46af5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc46af5a"]])

export default __exports__